<template>
  <div id="footDiv" class="div-middle-all" style="margin: 130px auto;">
    <el-footer>
      <el-row>
        <el-col :span="2">
          <el-menu
              class="el-menu-vertical-demo" style="border-right: none;" :router="true">
            <el-menu-item-group>
              <template slot="title">
                <span class="menu-title">酒店加盟</span>
              </template>
              <el-menu-item v-for="(item, idx) in jmMenus" :key="idx" :index="item.idx" :route="item.router">{{ item.name }}</el-menu-item>
            </el-menu-item-group>
          </el-menu>
        </el-col>
        <el-col :span="2">
          <el-menu
              class="el-menu-vertical-demo" style="border-right: none;" :router="true">
            <el-menu-item-group>
              <template slot="title">
                <span class="menu-title">关于陌上</span>
              </template>
              <el-menu-item v-for="(item, idx) in gyMenus" :key="idx" :index="item.idx" :route="item.router">{{ item.name }}</el-menu-item>
            </el-menu-item-group>
          </el-menu>
        </el-col>
        <el-col :span="3" style="float: right;">
          <el-image :src="dyQr" style="width: 120px;height: 120px;"></el-image>
          <div class="demonstration">抖音扫码了解酒店<br/> <span>关注陌上酒店抖音号</span></div>
        </el-col>
        <el-col :span="3"  style="float: right;">
          <el-image :src="wxQr" style="width: 120px;height: 120px;"></el-image>
          <div class="demonstration">微信扫码预定酒店<br/><span>关注陌上酒店公众号</span></div>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: "Foot",
  data() {
    return {
      jmMenus: [
        {name: '陌上优势', idx: '1', router: '/msStrategy'},
        {name: '合作攻略', idx: '2', router: '/cooperate'},
      ],
      gyMenus: [
        {name: '陌上简介', idx: '1', router: '/index'},
        {name: '旗下产品', idx: '2', router: '/brand'},
        {name: '企业愿景', idx: '3', router: '/msStrategy'},
        {name: '联系我们', idx: '4', router: '/contactWe'},
        {name: '媒体中心', idx: '5', router: '/news'},
      ],
      wxQr: require('../assets/images/微信扫码305-305.png'),
      dyQr: require('../assets/images/抖音扫码305-305.png'),
    }
  }
}
</script>

<style scoped>
  .menu-title {
    font-size: 18px;
    font-weight: 550;
    color: black;
  }
  #footDiv >>> .el-menu-item {
    height: 36px;
    line-height: 36px;
  }
  .demonstration{
    font-size: 14px;
    font-weight: 500;
    line-height:28px;
  }
  .demonstration >>> span{
    font-size: 12px;
    font-weight: 500;
    line-height:28px;
  }
  .demonstrations{
    font-size: 12px;
    font-weight: 500;
    line-height:28px;
  }
  .el-col-3{
    width: auto;
  }

</style>
